import React from "react";
import { StorefrontModal } from "web/react/components/storefront-modal";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { Text } from "web/react/emo/text";
import { VStack } from "web/react/emo/v-stack";
import { gettext } from "web/script/modules/django-i18n";
import * as styles from "./lyst-shop-partner-modal.css";

export interface LystShopPartnerModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export function LystShopPartnerModal({
    isOpen,
    onClose,
}: LystShopPartnerModalProps): React.ReactElement {
    const benefits = [
        gettext("shopfront.partner_modal.benefits.checkout"),
        gettext("shopfront.partner_modal.benefits.payment"),
        gettext("shopfront.partner_modal.benefits.stay_on_lyst"),
    ];

    return (
        <StorefrontModal
            title={gettext("shopfront.partner_modal.title")}
            isOpen={isOpen}
            onClose={onClose}
            isCheckout
        >
            <VStack spacing="sm">
                <Text textStyle="body-s" as="p">
                    {gettext("shopfront.partner_modal.intro")}
                    <br />
                    <br />
                    {gettext("shopfront.partner_modal.description")}
                </Text>
                <VStack spacing="xs">
                    <Text textStyle="body-bold">
                        {gettext("shopfront.partner_modal.benefits.title")}
                    </Text>
                    <ul className={styles.benefits}>
                        {benefits.map((benefit) => (
                            <li key={benefit} className={styles.benefit}>
                                <SVGIcon name="success-filled" className={styles.benefitIcon} />
                                <Text textStyle="body-s">{benefit}</Text>
                            </li>
                        ))}
                    </ul>
                </VStack>
            </VStack>
        </StorefrontModal>
    );
}
